if(window.innerWidth < 750) {
    var Index_icon_text_swiper = new Swiper(".Index_icon_text_grid", {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    });
}